<div class="dimension-header">
  <div class="header-title">
    <app-title-info [title]="pageTitle"></app-title-info>
  </div>
</div>

<app-divider-line></app-divider-line>

<div class="content-section pt-3">
  <app-notification-center-tabs></app-notification-center-tabs>
</div>